'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchArticle = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _reduxApiMiddleware = require('@aftonbladet/redux-api-middleware');

var _types = require('./types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/prefer-default-export */
var fetchArticle = exports.fetchArticle = function fetchArticle(_ref) {
    var id = _ref.id,
        endpoint = _ref.endpoint,
        _ref$force = _ref.force,
        force = _ref$force === undefined ? false : _ref$force,
        _ref$credentials = _ref.credentials,
        credentials = _ref$credentials === undefined ? 'omit' : _ref$credentials,
        _ref$headers = _ref.headers,
        headers = _ref$headers === undefined ? {} : _ref$headers;
    return (0, _defineProperty3.default)({}, _reduxApiMiddleware.CALL_API, {
        endpoint: endpoint,
        method: 'GET',
        credentials: credentials,
        types: [_types.ARTICLE_REQUEST, _types.ARTICLE_SUCCESS, _types.ARTICLE_FAILURE],
        bailout: function bailout(state) {
            return !force && !!state.article.id && id === state.article.id;
        },
        headers: headers
    });
};
/* eslint-enable import/prefer-default-export */
//# sourceMappingURL=actions.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/redux-article/lib/cjs/actions.js
 ** module id = 546
 ** module chunks = 1
 **/